import { render, staticRenderFns } from "./CNAETabela.vue?vue&type=template&id=4ce87264"
import script from "./CNAETabela.vue?vue&type=script&lang=js"
export * from "./CNAETabela.vue?vue&type=script&lang=js"
import style0 from "./CNAETabela.vue?vue&type=style&index=0&id=4ce87264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports